export const ACTIVE_NDVI_REPORT_STATUSES = new Set([
  'billing_pending',
  'scheduled',
  'in_progress',
  'refund_pending',
])

export const isNdviReportActive = (status) => ACTIVE_NDVI_REPORT_STATUSES.has(status)

export const canDeleteNdviReportFromList = (status) =>
  status === 'error' || status === 'payment_required'
